import React from "react";
import { CategoryIcon } from "../icons";

interface HeaderProps {
  inBLog?: boolean;
}

export default function Header({ inBLog }: HeaderProps) {
  const [loading, setIsLoading] = React.useState<boolean>(false);
  const [isNavOpen, setIsNavOpen] = React.useState<boolean>(false);

  const navigations = [
    {
      name: "Accueil",
      href: inBLog ? "/home" : "#home",
    },
    {
      name: "Comment ça marche ?",
      href: inBLog ? "/home" : "#how-it-works",
    },
    {
      name: "Blog",
      href: inBLog ? "/home" : "#blog",
    },
    {
      name: "Nos modèles",
      href: inBLog ? "/home" : "#our-models",
    },
    {
      name: "Contact",
      href: inBLog ? "/home" : "#contact",
    },
  ];

  const handleNavigationClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    href: string
  ) => {
    if (!inBLog) {
      event.preventDefault();
      setIsLoading(true);
      const targetElement = document.querySelector(href);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  return (
    <>
      {" "}
      <header
        id="home"
        className="flex items-center justify-between bg-primary-10 px-4 lg:px-2 rounded-full mb-6"
      >
        <a href="/">
          <img src="/assets/logo/logo.png" className="w-20 h-14" />
        </a>
        <ul className="hidden lg:flex items-center gap-8">
          {navigations.map((item) => (
            <li
              key={item.name}
              className="cursor-pointer font-normal text-lg text-header text-primary-20 hover:text-primary-20/80"
            >
              <a
                href={item.href}
                onClick={(e) => handleNavigationClick(e, item.href)}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="https://api.whatsapp.com/send?phone=33668733010"
          target="_blank"
          className="hidden lg:flex items-center bg-primary-100 hover:bg-primary-100/80 font-normal text-lg text-header text-white h-10 px-4 rounded-full"
        >
          Register
        </a>

        <CategoryIcon
          onClick={() => setIsNavOpen((prev) => !prev)}
          className="flex lg:hidden h-8 w-8"
        />
      </header>
      <nav className="z-50 lg:hidden flex flex-wrap items-center text-base justify-center my-2 pr-6">
        <section className="MOBILE-MENU flex lg:hidden">
          <div className={isNavOpen ? "showMenuNav" : "hideMenuNav"}>
            <div
              className="absolute top-0 right-0 px-8 py-8"
              onClick={() => setIsNavOpen(false)}
            >
              <svg
                className="h-8 w-8 text-gray-600"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </div>
            <ul className="flex flex-col items-center justify-between min-h-[250px]">
              {navigations.map((item, index) => {
                return (
                  <li key={index} className="my-8 uppercase">
                    <a
                      href={item.href}
                      className={
                        "font-medium text-primary-20 hover:text-primary-20/80 mr-4 font-lexend  text-sm uppercase"
                      }
                    >
                      {item.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </section>
      </nav>
      <style>{`
        .hideMenuNav {
          display: none;
        }
        .showMenuNav {
          display: block;
          position: absolute;
          width: 100%;
          height: 100vh;
          top: 0;
          left: 0;
          background: white;
          z-index: 10;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: center;
        }
      `}</style>
    </>
  );
}
